/**
 * VDB Developer Console
 * Build 003 / Commit 003.3
 */
(function (window) {
  "use strict";
  const VDB = window.VDB = window.VDB || {};
  const C = window.VDBConfig || {};

  VDB.dev = {
    async report() {
      const health = await VDB.api.health();
      const report = {
        framework: VDB.info?.() || {
          version: C.version,
          build: C.build,
          commit: C.commit
        },
        health,
        diagnostics: VDB.api.diagnostics(),
        selectedVehicle: VDB.vehicle?.get?.() || null
      };
      console.group("[VDB] Developer Report");
      console.table({
        provider: health.provider,
        status: health.status,
        source: health.source,
        makes: health.makes,
        latencyMs: health.latencyMs,
        requests: health.metrics?.requests,
        cacheHits: health.metrics?.cacheHits,
        pages: health.metrics?.pages
      });
      console.log(report);
      console.groupEnd();
      return report;
    },
    clearCache() {
      VDB.api.clearCache();
      console.info("[VDB] Storefront cache cleared.");
    }
  };

  if (C.debug) {
    console.info("[VDB] Developer Console ready. Run: await VDB.dev.report()");
  }
})(window);
